import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'

import useTranslations from '../../../../../i18n/useTranslations'
import CompleteInfoItem from '../../../../../ui/components/listItem/CompleteInfoItem'
import { ReactComponent as Clock } from '../../../../../assets/icons/clock.svg'
import { ReactComponent as Phone } from '../../../../../assets/icons/phone.svg'
import { ReactComponent as MapPin } from '../../../../../assets/icons/map-pin.svg'

import styles from './styles'

export const ScheduleMock = () => {
  return (
    <Box sx={styles.schedule}>
      <Typography variant="h4">
        Lunes: De 10:00 a 14:00 y de 17:00-20:30
      </Typography>
      <Typography variant="h4">Martes: De 10:00-14:00 y 17:00-20:30</Typography>
      <Typography variant="h4">
        Miércoles: De 10:00-14:00 y 17:00-20:30
      </Typography>
      <Typography variant="h4">Jueves: De 10:00-14:00 y 17:00-20:30</Typography>
      <Typography variant="h4">
        Viernes: De 10:00-14:00 y 17:00-20:30
      </Typography>
    </Box>
  )
}

const PickupPointSelected = ({ pickupPoint }) => {
  const formatMessage = useTranslations()

  const [scrollTop, setScrollTop] = useState(0)
  const [scrollBottom, setScrollBottom] = useState(0)

  const handleScroll = event => {
    setScrollTop(event.currentTarget.scrollTop > 0)
    setScrollBottom(
      event.currentTarget.scrollHeight - event.currentTarget.scrollTop ===
        event.currentTarget.clientHeight,
    )
  }
  const scrolledTop = scrollTop ? 'scrolledTop' : ''
  const scrolledBottom = scrollBottom ? 'scrolledBottom' : ''

  return (
    <Box sx={styles.pickupPointSelectedWrapper}>
      <CompleteInfoItem
        icon={<MapPin />}
        title={pickupPoint.name}
        subtitle={pickupPoint.address}
        // secondaryItem="2.1 km"
      />
      <Box sx={styles.scrolledContainer}>
        <Box
          sx={{
            ...styles.scrolledWrapper,
            ...styles[scrolledTop],
            ...styles[scrolledBottom],
          }}
          onScroll={handleScroll}
        >
          <CompleteInfoItem
            icon={<Phone />}
            title={formatMessage('noun:phone')}
            subtitle={pickupPoint.phoneNumber}
            sx={styles.completeInfoItemNested}
          />
          <CompleteInfoItem
            icon={<Clock />}
            title={formatMessage('noun:schedule')}
            subtitle={pickupPoint.schedule.map(schedule => (
              <p
                key={`${schedule.dayName}:${schedule.openingHours}`}
                className="radio-extraInfoData font-h4"
              >
                {schedule.dayName}: {schedule.openingHours}
              </p>
            ))}
            sx={styles.completeInfoItemNested}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default PickupPointSelected
